import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tComponent Limits\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "form-contents" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-10 no-padding" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_11 = { class: "input-group top_search" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_13 = { class: "input-group top_search" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_15 = { class: "input-group top_search" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_17 = { class: "input-group top_search" };
const _hoisted_18 = { class: "clearfix" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_20 = { class: "input-group top_search" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_22 = { class: "input-group top_search" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_24 = { class: "input-group top_search" };
const _hoisted_25 = { class: "col-xs-12 col-sm-12 col-md-2" };
const _hoisted_26 = { class: "float-start pw100" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Search", -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Clear", -1 /* HOISTED */);
const _hoisted_31 = { class: "col-xs-12 col-sm-12" };
const _hoisted_32 = { class: "card bg-white data-grid component-limits-grid detached overflow-x-auto top20" };
const _hoisted_33 = { class: "table table-hover bottom0 pw100" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Measurement Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Alarm Type"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "Component Name"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "String State"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "When Created"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Low Critical"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Low Warning"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "High Warning"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "High Critical")
    ])
], -1 /* HOISTED */);
const _hoisted_35 = { class: "text-end" };
const _hoisted_36 = { class: "text-end" };
const _hoisted_37 = { class: "text-end" };
const _hoisted_38 = { class: "text-end" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "10"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "There are no records matching your criteria.")
], -1 /* HOISTED */);
const _hoisted_41 = [
    _hoisted_40
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.companyId,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.companyId) = $event)),
                                        options: _ctx.companies,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Select a company",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.systemId,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.systemId) = $event)),
                                        options: _ctx.systemsFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Select a system",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.stringId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.stringId) = $event)),
                                        options: _ctx.stringsFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Select a string",
                                        class: "multiselect-small",
                                        disabled: !_ctx.query.systemId
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.componentTypeId,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.componentTypeId) = $event)),
                                        options: _ctx.componentTypes,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Component type",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.componentId,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.componentId) = $event)),
                                        options: _ctx.componentsFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Select a component",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.measurementTypeId,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.measurementTypeId) = $event)),
                                        options: _ctx.measurementTypes,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Measurement type",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.stringStateId,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.stringStateId) = $event)),
                                        options: _ctx.stringStates,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "String state",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_multiselect, {
                                        modelValue: _ctx.alarmTypeId,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.alarmTypeId) = $event)),
                                        options: _ctx.alarmTypesFiltered,
                                        "track-by": "value",
                                        label: "text",
                                        showLabels: false,
                                        placeholder: "Alarm type",
                                        class: "multiselect-small"
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "options"])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_b_button, {
                                variant: "primary pw100 bottom10",
                                onClick: _ctx.search,
                                disabled: !_ctx.query.systemId
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_27,
                                    _hoisted_28
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick", "disabled"]),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                variant: "primary pw100",
                                onClick: _ctx.resetFilters
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_29,
                                    _hoisted_30
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("table", _hoisted_33, [
                            _hoisted_34,
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(item.measurementTypeName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(item.alarmTypeName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(item.stringStatusName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.getDateFormated(item.whenCreated)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.formatLimit(item.lowCritical)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.formatLimit(item.lowWarning)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.formatLimit(item.highWarning)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatLimit(item.highCritical)), 1 /* TEXT */)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
